module.exports = __webpack_public_path__ + "img/imgexconrew.f7715b42.png";